import router, { constantRoutes } from './router'
import store from './store'
import { get, isNull } from 'lodash'
import { Message } from 'element-ui'
import ls from '@/utils/localstorage' // get token from cookie
import { getPageTitle } from '@/utils/helper' // no redirect whitelist
import { setOrgConfig } from './orgConfig'
import { keepAliveConfig } from '@/config/keepAlive'
import { isValidLanguageCode, loadLanguageAsync, t } from '@/plugins/i18n/i18n'
import Cookies from 'js-cookie'
import localStoreKeys from './config/localStoreKeys'
import { collectRouteNames, isShopScopeRoute } from '@/utils/routeScope'
const whiteList = [
  '/login',
  /^(\/read-member-history-file\/).+/,
]

// constantRoutes 為不需要分店 context 的基本頁面（登入、redirect、404、帳號設定等）
const constantRouteNames = collectRouteNames(constantRoutes)

function getModuleFromPath (path) {
  if (path.includes('/reservations')) return 'reservations'
  if (path.includes('/public-appointment')) return 'publicAppointment'
  return ''
}
function getBrowserLanguage () {
  const deviceLanguage = window.navigator.language.toLowerCase() // 瀏覽器語言
  let browserLanguage

  if (deviceLanguage === 'zh-tw') {
    browserLanguage = 'zh'
  } else if (deviceLanguage === 'ja') {
    browserLanguage = 'jp'
  } else if (deviceLanguage === 'ko') {
    browserLanguage = 'kr'
  } else {
    browserLanguage = 'en'
  }

  return browserLanguage
}
router.beforeEach(async (to, from, next) => {
  console.log(to.params)
  console.group('page change')
  console.log('from', from.name)
  console.log('to', to.name)
  console.groupEnd()

  // 先從 localStorage 取語言設定 (key: 'old_locale')，若無再 fallback 到舊的 cookie
  const storedLang = window.localStorage.getItem('old_locale') || Cookies.get('old_locale')
  console.log('🌐 storedLang', storedLang ? JSON.parse(JSON.stringify(storedLang)) : undefined)
  let browserLanguage = storedLang && isValidLanguageCode(storedLang) ? storedLang : getBrowserLanguage()
  console.log('🌐 browserLanguage - init', browserLanguage ? JSON.parse(JSON.stringify(browserLanguage)) : undefined)
  if (to.name !== from.name) store.commit('app/TOGGLE_PAGE_CHANGING', true)

  // TODO 預計棄用
  if (get(keepAliveConfig, `${to.name}`)) {
    store.commit('app/SET_KEEP_ALIVE', to.name)
  }

  if (!from.name) {
    await setOrgConfig()

    // 特殊需求 - 特定頁面轉址 ??
    if (to.path.includes('/order-detail/')) {
      ls.set(localStoreKeys.lastRoute, to)
    }
  }

  console.log('🌐 store.getters.isOverseasShop - 1', store.getters.isOverseasShop ? JSON.parse(JSON.stringify(store.getters.isOverseasShop)) : undefined)
  if (!isNull(store.getters.isOverseasShop)) {
    const isFirstVisit = !localStorage.getItem('first_visited')
    console.log('🌐 isFirstVisit', isFirstVisit)
    if (isFirstVisit) {
      console.log('🌐 store.getters.isOverseasShop - 2', store.getters.isOverseasShop ? JSON.parse(JSON.stringify(store.getters.isOverseasShop)) : undefined)
      browserLanguage = store.getters.isOverseasShop ? getBrowserLanguage() : 'zh'
      localStorage.setItem('first_visited', 'visited')
    }
  }

  await loadLanguageAsync(browserLanguage)

  // set page title
  document.title = getPageTitle(to.meta.title)

  // determine whether the user has logged in
  const hasToken = ls.getToken()
  const currentModule = getModuleFromPath(to.path)
  store.commit('app/SET_CURRENT_MODULE', currentModule)

  if (to.path === '/auth-login') return next()
  if (to.name === 'ForgetPassword') return next()
  if (to.name === 'ResetPassword') return next()
  if (to.name === 'SetPassword') return next()
  if (to.path === '/not-found') return next()
  if (hasToken) {
    // if is logged in, redirect to the default page
    if (to.path === '/login' || to.path === '/') {
      const lastRoute = ls.get(localStoreKeys.lastRoute)
      if (lastRoute) {
        return next({ name: 'Redirect', replace: true })
      }

      if (to.path === '/' && from.name === 'BranchShopOptions' && store.getters.shop) {
        return next({ name: 'HomePage', replace: true })
      }

      return next({ path: '/branch-shop-options', replace: true })
    } else {
      if (store.getters.shop && !get(store.state, 'shop.shopConfig.id')) {
        store.dispatch('shop/findShop', { shopId: store.getters.shop })
        store.dispatch('shop/getGlobalShopData', { shopId: store.getters.shop })
      }

      const hasRoles = store.getters.role
      if (hasRoles) {
        // 店家層級頁面若沒有已選定的分店，所有 /api-admin/:ShopId API 會以 shopId=null 發出，
        // 導致後端收到字串 'null' 並在 uuid 欄位查詢時報錯，因此先導回分店選擇頁 [CBGISSUE-259]
        if (!store.getters.shop && isShopScopeRoute(to, constantRouteNames)) {
          Message.warning(t('common.message.selectBranchFirst'))
          return next({ name: 'BranchShopOptions', replace: true })
        }

        try {
          // 根據路由 scopeType 自動同步 sidebarPage 狀態
          const currentSidebarPage = store.state.app.sidebarPage
          const expectedSidebarPage = to.meta.scopeType === 'OrgId'
            ? 1 // 組織層級
            : (store.getters.shop ? 2 : currentSidebarPage) // 店家層級（已選擇店家時）

          if (currentSidebarPage !== expectedSidebarPage) {
            await store.dispatch('app/setSidebarPage', expectedSidebarPage)
          }
        } catch (error) {
          // sidebarPage 只是側邊欄層級（組織層／店家層）的狀態同步，失敗不應阻擋導航。
          // 若在此以 next(false) 中止導航，afterEach 不會觸發、onError 也不會觸發
          // （next(false) 產生的是 NavigationFailure，被 vue-router 3.6 排除在 errorCbs 之外），
          // 會讓 app/TOGGLE_PAGE_CHANGING 卡在 true，畫面永遠停在載入中。
          // 因此改為記錄錯誤後照常放行，讓導航完成並由 afterEach 重設 pageChanging。
          console.error('[permission] sync sidebarPage failed', error)
        }
        return next()
      } else {
        try {
          // get user info
          const { features, shopPlan } = await store.dispatch('user/getMe')

          const isTempPassword = get(store.state, 'user.user.AuthEmail.isTempPassword')
          if (isTempPassword) {
            return next({ path: '/set-password', query: { tempPedRest: true } })
          }

          // generate accessible routes map based on role
          const accessRoutes = await store.dispatch('permission/generateRoutes', { features, shopPlan })

          // dynamically add accessible routes
          accessRoutes.map(item => router.addRoute(item))

          // hack method to ensure that addRoutes is complete
          // set the replace: true, so the navigation will not leave a history
          next({ ...to, replace: true })
        } catch (error) {
          if (error === 503) return alert('系統維護中，將於維護作業完成後恢復相關功能')
          // remove token and go to Login page to re-Login
          await store.dispatch('auth/logout')
          await store.dispatch('user/deleteAccount', { token: hasToken })
          // 401 的真正訊息（Session 已失效…）已由 api/instance.js 的攔截器顯示並導向 Login，
          // 這裡的 error 只是攔截器 reject 出來的狀態碼，再跳一則「401」對使用者沒有意義
          if (error !== 401) Message.error(error || 'Has Error')
          next('/login')
        }
      }
    }
  } else {
    /* has no token */
    const whiteUrl = whiteList.find(l => {
      return to.path.indexOf(l) !== -1 || to.fullPath.match(l)
    })
    if (whiteUrl) {
      // in the free Login whitelist, go directly
      return next()
    } else {
      ls.set(localStoreKeys.lastRoute, to)
      // other pages that do not have permission to access are redirected to the Login page.
      return next('/login')
    }
  }
})
